export default "/images/36076f9c6c60258835fc52c9aa847953.avif";